import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Role } from '../../shared/entities/role/role';
import { GroupsService } from '../../shared/services/groups/groups.service';
import { LoadingService } from '../../shared/services/loading.service';
import { LocationService } from '../../shared/services/location/location.service';
import { UsersService } from '../../shared/services/users/users.service';
import { EditDialogComponent } from '../editDialog/editDialogComponent';
import { EditDialogInstance } from '../editDialog/editDialogService';

@Component({
  selector: 'app-add-roles-dialog',
  templateUrl: './add-roles-dialog.component.html',
  styleUrls: ['./add-roles-dialog.component.scss']
})
export class AddRolesDialogComponent
  implements EditDialogInstance {

    availableRoles: Role[];
    assignedRoles: Role[]; // roles that are already assigned to the user or group
    assignablesRoles: Role[];
    selectedRolesModel: Role[];
    rolesForm: FormGroup;

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    public userService: UsersService,
    public groupService: GroupsService,
    public loadingService: LoadingService,
    public locationService: LocationService
  ) {
    // this.groupService.getGroups().pipe(
    //   take(1)
    // ).subscribe((groups) => {
    //   this.groups = groups;
    // });
    // this.locationService.getLocations().pipe(
    //   take(1)
    // ).subscribe((locations) => {
    //   this.locations = locations;
    // });

    // we do not need a form here for the addition for roles, 
    // but currently the dialog service needs a form to be passed
    // so we use the form to mock the interface. Maybe we can change the service
    // in the future to accept a more generic output for "valid"
    this.rolesForm = new FormGroup({});
    this.rolesForm.addControl('roles', new FormControl(undefined, Validators.required));

    if (this.config.data) {
      this.assignedRoles = this.config?.data?.assignedRoles;
      this.availableRoles = this.config?.data?.availableRoles
      // assignables roles are all available roles minus the ones the user already has
      this.assignablesRoles = new Array<Role>();
      this.availableRoles.forEach(role => {
        let isAssignable = true
        for (let i = 0; i < this.assignedRoles.length; i++) {
          if (role.id === this.assignedRoles[i].id) {
            isAssignable = false;
            return;
          }
        }
        if (isAssignable) {
          this.assignablesRoles.push(role);
        }
      });
    }

  }

  onSelectionChange(event: any): void {
    console.log(event);
    this.rolesForm.get('roles')?.setValue(event);
  }


  onConfirm(editDialogComponent: EditDialogComponent<any>): void {
    this.ref.close(this.selectedRolesModel);
  }

  onReject(editDialogComponent: EditDialogComponent<any>): void {
    this.ref.close(false);
  }

  getEditForm(): FormGroup {
    return this.rolesForm;
  }

}
